import Perfil from '@/components/Perfil.vue'
import Ficha from '@/components/builder/Ficha.vue'
import PostList from '@/components/builder/PostList.vue'
import Productos from '@/components/builder/Productos.vue'
import EditarPerfil from '@/components/builder/EditarPerfilAnterior.vue'
import Favoritos from '@/components/builder/Favoritos.vue'
import EditarFechaPais from './components/builder/EditarFicha.vue'
import EditarPassword from './components/builder/EditarPassword.vue'
import EditarDatosRedes from './components/builder/EditarDatosRedes.vue'
import ListaColapsada from './components/builder/ListaColapsada.vue'
import BannerPromocional from './components/builder/BannerPromocional.vue'
import BannerPromocionalCopiar from './components/builder/BannerPromocionalCopiar.vue'
import BadgeSuscriptor from './components/builder/BadgeSuscriptor.vue'
import FormularioDinamico from './components/builder/FormularioDinamico.vue'
import Cuento from './components/builder/Cuento.vue'
import FormularioDinamicoUno from './components/builder/FormularioDinamicoUno.vue'
import Genero from './components/builder/estadisticas/Genero.vue'
import Generos from './components/builder/estadisticas/Generos.vue'
import Tiempo from './components/builder/estadisticas/Tiempo.vue'
import RankingCuentos from './components/builder/estadisticas/RankingCuentos.vue'
import RankingLectores from './components/builder/estadisticas/RankingLectores.vue'
import BotonCopiar from './components/builder/BotonCopiar.vue'
import FavoritosAudio from './components/builder/FavoritosAudio.vue'
import AudioHistoria from './components/builder/AudioHistoria.vue'
import GruposWhatsapp from './components/builder/GruposWhatsapp.vue'
import ProgressBar from './components/builder/ProgressBar.vue'
import Votar from './components/builder/Votar.vue'
// Nuevos componentes
import General from './components/builder/estadisticas/General.vue'
import EstadoCivil from './components/builder/estadisticas/EstadoCivil.vue'
import Estudios from './components/builder/estadisticas/Estudios.vue'
import Hijos from './components/builder/estadisticas/Hijos.vue'
import Region from './components/builder/estadisticas/Region.vue'
import Profesion from './components/builder/estadisticas/Profesion.vue'
import SignoZodiacal from './components/builder/estadisticas/SignoZodiacal.vue'
import CuentoNuevo from './components/builder/CuentoNuevo.vue'
import Globales from './components/builder/estadisticas/Globales.vue'
import Talleres from '@/components/builder/Talleres.vue';
import AgendaDinamica from '@/components/builder/AgendaDinamica.vue';

// Rankings

export const registeredComponents = [
    {
        component: AgendaDinamica,
        name: 'Talleres - Agenda Dinámica',
    },
    {
        component: Talleres,
        name: 'Shopify - Talleres',
    },
    {
        component: Globales,
        name: 'Globales - Estadisticas de Cuento',
        noWrap: true,
    },
    {
        // CuentoNuevo
        component: CuentoNuevo,
        name: 'Cuento Nuevo',
        inputs: [
            {
                name: 'submitText',
                type: 'string',
            },
            // Enumerar todos los estados posibles
            {
                name: 'estado',
                type: 'enum',
                enum: [
                    {
                        label: 'Cerrado',
                        value: 'cerrado',
                    },
                    {
                        label: 'Editar Cuerpo',
                        value: 'editar_cuerpo',
                    },
                    {
                        label: 'Editar Cuerpo y Resumen',
                        value: 'editar_cuerpo_y_resumen',
                    },
                    {
                        label: 'Editar Audio',
                        value: 'editar_audio',
                    },
                    {
                        label: 'Editar Todo',
                        value: 'editar_todo',
                    },
                ]
            },
            {
                name: 'editable',
                friendlyName: '¿Es editable?',
                type: 'boolean',
            },
        ]
    },
    {
        component: General,
        name: 'General - Estadisticas de Cuento',
        noWrap: true,
        inputs: [
            {
                name: 'descripcion',
                type: 'richText',
                defaultValue: '<p>Texto de descripción</p>',
            },
            {
                name: 'tipoGrafico',
                type: 'string',
                enum: ['lecturas', 'escuchas'],
                defaultValue: 'lecturas',
                helperText: 'Selecciona el tipo de gráfico a mostrar',
            },
        ],

    },
    {
        component: EstadoCivil,
        name: 'Estado Civil - Estadisticas de Cuento',
        noWrap: true,
        inputs: [
            {
                name: 'descripcion',
                type: 'richText',
                defaultValue: '<p>Texto de descripción</p>',
            },
            {
                name: 'tipoGrafico',
                type: 'string',
                enum: ['lecturas', 'escuchas'],
                defaultValue: 'lecturas',
                helperText: 'Selecciona el tipo de gráfico a mostrar',
            },
        ],
    },
    {
        component: Estudios,
        name: 'Estudios - Estadisticas de Cuento',
        noWrap: true,
        inputs: [
            {
                name: 'descripcion',
                type: 'richText',
                defaultValue: '<p>Texto de descripción</p>',
            },
            {
                name: 'tipoGrafico',
                type: 'string',
                enum: ['lecturas', 'escuchas'],
                defaultValue: 'lecturas',
                helperText: 'Selecciona el tipo de gráfico a mostrar',
            },
        ],
    },
    {
        component: Hijos,
        name: 'Hijos - Estadisticas de Cuento',
        noWrap: true,
        inputs: [
            {
                name: 'descripcion',
                type: 'richText',
                defaultValue: '<p>Texto de descripción</p>',
            },
            {
                name: 'tipoGrafico',
                type: 'string',
                enum: ['lecturas', 'escuchas'],
                defaultValue: 'lecturas',
                helperText: 'Selecciona el tipo de gráfico a mostrar',
            },
        ],
    },
    {
        component: Region,
        name: 'Region - Estadisticas de Cuento',
        noWrap: true,
        inputs: [
            {
                name: 'descripcion',
                type: 'richText',
                defaultValue: '<p>Texto de descripción</p>',
            },
            {
                name: 'tipoGrafico',
                type: 'string',
                enum: ['lecturas', 'escuchas'],
                defaultValue: 'lecturas',
                helperText: 'Selecciona el tipo de gráfico a mostrar',
            },
        ],
    },
    {
        component: Profesion,
        name: 'Profesion - Estadisticas de Cuento',
        noWrap: true,
        inputs: [
            {
                name: 'descripcion',
                type: 'richText',
                defaultValue: '<p>Texto de descripción</p>',
            },
            {
                name: 'tipoGrafico',
                type: 'string',
                enum: ['lecturas', 'escuchas'],
                defaultValue: 'lecturas',
                helperText: 'Selecciona el tipo de gráfico a mostrar',
            },
        ],
    },
    {
        component: SignoZodiacal,
        name: 'Signo Zodiacal - Estadisticas de Cuento',
        noWrap: true,
        inputs: [
            {
                name: 'descripcion',
                type: 'richText',
                defaultValue: '<p>Texto de descripción</p>',
            },
            {
                name: 'tipoGrafico',
                type: 'string',
                enum: ['lecturas', 'escuchas'],
                defaultValue: 'lecturas',
                helperText: 'Selecciona el tipo de gráfico a mostrar',
            },
        ],
    },
    {
        component: Genero,
        name: 'Genero - Estadisticas de Cuento',
        noWrap: true,
        inputs: [
            {
                name: 'descripcion',
                type: 'richText',
                defaultValue: '<p>Texto de descripción</p>',
            },
            {
                name: 'tipoGrafico',
                type: 'string',
                enum: ['lecturas', 'escuchas'],
                defaultValue: 'lecturas',
                helperText: 'Selecciona el tipo de gráfico a mostrar',
            },
        ]
    },
    {
        component: Generos,
        name: 'Generos - Estadisticas de Cuento',
        noWrap: true,
        inputs: [
            {
                name: 'descripcion',
                type: 'richText',
                defaultValue: '<p>Texto de descripción</p>',
            },
            {
                name: 'tipoGrafico',
                type: 'string',
                enum: ['lecturas', 'escuchas'],
                defaultValue: 'lecturas',
                helperText: 'Selecciona el tipo de gráfico a mostrar',
            },
        ],
    },

    {
        component: Votar,
        name: 'Votar',
    },
    {
        component: Ficha,
        name: 'Ficha',
    },
    {
        component: ProgressBar,
        name: 'ProgressBar',
        inputs: [
            {
                name: 'startDate',
                type: 'string',
                defaultValue: '2025-02-28',
            },
            // totalMeetings
            {
                name: 'totalMeetings',
                type: 'number',
                defaultValue: 10,
                helperText: 'Total de reuniones',
            },
            {
                name: 'color',
                type: 'string',
                defaultValue: 'bg-blue-500',
                helperText: 'Color de la barra de progreso',
            },
        ]
    },
    {
        component: GruposWhatsapp,
        name: 'GruposWhatsapp',
    },
    {
        component: AudioHistoria,
        name: 'AudioHistoria',
        inputs: [
            {
                name: 'audioUrl',
                type: 'string',
            }]
    },
    {
        component: RankingCuentos,
        name: 'RankingCuentos',
        inputs: [
            {
                name: 'tipoGrafico',
                type: 'string',
                enum: ['lecturas', 'audios'],
                defaultValue: 'lecturas',
                helperText: 'Selecciona el tipo de gráfico a mostrar',
            },
        ]
    },
    {
        component: RankingLectores,
        name: 'RankingLectores',
        inputs: [
            {
                name: 'tipoGrafico',
                type: 'string',
                enum: ['lecturas', 'audios'],
                defaultValue: 'lecturas',
                helperText: 'Selecciona el tipo de gráfico a mostrar',
            },
        ]
    },
    {
        component: BotonCopiar,
        name: 'BotonCopiar',
        inputs: [
            {
                name: 'bgColor',
                type: 'string',
                defaultValue: 'blue-500',
            },
            {
                name: 'textColor',
                type: 'string',
                defaultValue: 'white',
            },
            {
                name: 'hoverBgColor',
                type: 'string',
                defaultValue: 'blue-600',
            },
            {
                name: 'buttonText',
                type: 'string',
                defaultValue: 'Copiar',
            },
            {
                name: 'textToCopy',
                type: 'string',
                defaultValue: 'Texto predeterminado a copiar',
            },
        ]
    },
    {
        component: Tiempo,
        name: 'Cuento: Tiempo',
        // Agregar input de texto largo
        inputs: [
            {
                name: 'descripcion',
                type: 'richText',
                defaultValue: '<p>Texto de descripción</p>',
            },
        ],
    },
    {
        component: Cuento,
        name: 'Cuento',
        inputs: [
            {
                name: 'submitText',
                type: 'string',
            },
            {
                name: 'titulo',
                friendlyName: 'Mostrar título',
                type: 'boolean',
                defaultValue: true,
            },
            {
                name: 'tema',
                friendlyName: 'Mostrar tema',
                type: 'boolean',
                defaultValue: true,
            },
            {
                name: 'resumen',
                friendlyName: 'Mostrar resumen',
                type: 'boolean',
                defaultValue: true,
            },
            {
                name: 'audio',
                friendlyName: 'Mostrar audio',
                type: 'boolean',
                defaultValue: true,
            },
            {
                name: 'cuento',
                friendlyName: 'Mostrar cuento',
                type: 'boolean',
                defaultValue: true,
            },
            {
                name: 'editable',
                friendlyName: '¿Es editable?',
                type: 'boolean',
            }
        ],
    },
    {
        // FormularioDinamico
        component: FormularioDinamico,
        name: 'Formulario Dinámico',
    },
    {
        // FormularioDinamico
        component: FormularioDinamicoUno,
        name: 'Formulario Dinámico UNO',
    },
    {
        component: BadgeSuscriptor, // Reemplaza con el nombre de tu componente
        name: 'BadgeSuscriptor',
        inputs: [
            {
                name: 'text',
                type: 'richText',
                defaultValue: 'Suscripción activa',
            },
            {
                name: 'iconColor',
                type: 'string',
                defaultValue: '#10B981',
            },
            {
                name: 'bgColor',
                type: 'string',
                enum: ['bg-blue-500', 'bg-red-500', 'bg-green-500', 'bg-yellow-500', 'bg-indigo-500', 'bg-purple-500', 'bg-pink-500'],
                defaultValue: 'bg-green-500',
                helperText: 'Color de fondo de la etiqueta',
            },
            {
                name: 'textColor',
                type: 'string',
                enum: ['text-white', 'text-black', 'text-gray-800'],
                defaultValue: 'text-white',
                helperText: 'Color del texto de la etiqueta',
            },
        ],
    },
    {
        component: BannerPromocionalCopiar, // Reemplaza con el nombre de tu componente
        name: 'BannerPromocionalCopiar',
        inputs: [
            {
                name: 'text',
                type: 'richText',
                defaultValue: '80% OFF EN TODOS LOS CURSOS DE HERNÁN CON TU CÓDIGO: #ORSAI2025',
            },
            {
                name: 'buttonText',
                type: 'string',
                defaultValue: 'Cupón de descuento',
            },
            {
                name: 'link',
                type: 'url',
                defaultValue: '#',
            }

        ],
    },
    {
        component: BannerPromocional, // Reemplaza con el nombre de tu componente
        name: 'BannerPromocional',
        inputs: [
            {
                name: 'text',
                type: 'richText',
                defaultValue: '80% OFF EN TODOS LOS CURSOS DE HERNÁN CON TU CÓDIGO: #ORSAI2025',
            },
            {
                name: 'buttonText',
                type: 'string',
                defaultValue: 'Usar cupón',
            },
            {
                name: 'link',
                type: 'url',
                defaultValue: '#',
            },
            {
                name: 'backgroundColor',
                type: 'string',
                enum: ['bg-blue-500', 'bg-red-500', 'bg-green-500', 'bg-yellow-500', 'bg-indigo-500', 'bg-purple-500', 'bg-pink-500'],
                defaultValue: 'bg-blue-500',
                helperText: 'Clase de color de fondo en TailwindCSS',
            },
            {
                name: 'textColor',
                type: 'string',
                enum: ['text-white', 'text-black', 'text-gray-800'],
                defaultValue: 'text-white',
                helperText: 'Clase de color de texto en TailwindCSS',
            },
            {
                name: 'buttonBackgroundColor',
                type: 'string',
                enum: ['bg-black', 'bg-white', 'bg-gray-800'],
                defaultValue: 'bg-black',
                helperText: 'Clase de color de fondo del botón en TailwindCSS',
            },
            {
                name: 'buttonTextColor',
                type: 'string',
                enum: ['text-white', 'text-black'],
                defaultValue: 'text-white',
                helperText: 'Clase de color de texto del botón en TailwindCSS',
            },
        ],
    },
    {
        image: 'https://unpkg.com/heroicons@2.2.0/24/outline/view-list.svg',
        component: ListaColapsada,
        name: 'ListaColapsada',
        inputs: [
            {
                name: 'titulo',
                type: 'string',
                defaultValue: 'Título de la lista',
            },
            {
                name: 'items',
                type: 'list',
                subFields: [
                    {
                        name: 'titulo',
                        type: 'string',
                        defaultValue: 'Título del item',
                    },
                    {
                        name: 'contenido',
                        type: 'string',
                        defaultValue: 'Contenido del item',
                    },
                ],
                defaultValue: [
                    { titulo: 'Revista Orsai N. 12', contenido: '28 Feb, 2025' },
                    { titulo: 'Revista Orsai N. 13', contenido: '14 May, 2025' },
                    { titulo: 'Revista Orsai N. 14', contenido: '29 Jul, 2025' },
                    { titulo: 'Revista Orsai N. 15', contenido: '13 Oct, 2025' },
                    { titulo: 'Revista Orsai N. 16', contenido: '28 Dic, 2025' },
                ],
            },
        ],
    },
    {
        image: 'https://unpkg.com/heroicons@2.2.0/24/outline/share.svg',
        component: EditarDatosRedes,
        name: 'EditarDatosRedes',
    },
    {
        image: 'https://unpkg.com/css.gg@2.0.0/icons/svg/password.svg',
        component: EditarPassword,
        name: 'EditarPassword',
    },
    {
        image: 'https://unpkg.com/heroicons@2.2.0/24/outline/user-circle.svg',
        component: EditarPerfil,
        name: 'EditarPerfil',
        inputs: [
            {
                name: 'classButton',
                friendlyName: 'Clase del botón',
                type: 'string',
                defaultValue: null,
            },
        ]
    },
    {
        component: Favoritos,
        name: 'Cuentos Favoritos',
    },
    {
        component: FavoritosAudio,
        name: 'Audios Favoritos',
    },
    // EditarFechaPais
    {
        component: EditarFechaPais,
        name: 'EditarFechaPais',
    },
    {
        image: 'https://unpkg.com/heroicons@2.2.0/24/outline/list-bullet.svg',
        component: PostList,
        name: 'PostList',
        inputs: [
            {
                name: 'text',
                type: 'string',
                defaultValue: 'World',
            },
        ],
    },
    {
        image: 'https://unpkg.com/heroicons@2.2.0/24/outline/shopping-bag.svg',
        component: Productos,
        name: 'Productos',
        inputs: [
            {
                name: 'text',
                type: 'string',
                defaultValue: 'World',
            },
        ],
    },
    {
        image: 'https://unpkg.com/heroicons@2.2.0/24/outline/user-circle.svg',
        component: Perfil,
        name: 'Perfil',
        inputs: [
            {
                name: 'hideName',
                friendlyName: 'Ocultar nombre',
                type: 'boolean',
                defaultValue: true,
            },
            {
                name: 'config',
                friendlyName: 'Campos a mostrar',
                type: 'list',
                subFields: [
                    {
                        name: 'key',
                        type: 'string',
                        enum: ['nombre', 'apellido', 'email', 'telefono', 'provincia', 'pais', 'idSocio', 'urlImagen'],
                        helperText: 'Selecciona el dato del usuario que deseas mostrar.',
                    },
                    {
                        name: 'label',
                        type: 'string',
                        helperText: 'Etiqueta que aparecerá junto al dato del usuario.',
                    },
                ],
                defaultValue: [],
            },
        ],
    },
    {
        component: PostList,
        name: 'PostList',
        inputs: [
            {
                name: 'text',
                type: 'string',
                defaultValue: 'World',
            },
        ],
    },
    {
        component: Productos,
        name: 'Productos',
        inputs: [
            {
                name: 'text',
                type: 'string',
                defaultValue: 'World',
            },
        ],
    }
]